import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import { BsArrowLeftCircle } from 'react-icons/bs';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'

const QuestionsModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className='w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 text-lg overflow-y-auto'
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div
            className='flex flex-row justify-start items-center cursor-pointer'
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={() => {
              playSong(songsName.TAP)

              props.backToDrawerMenu()
            }}
          >
            <BsArrowLeftCircle className="w-8 h-8 text-blue-primary" />
          </div>

          <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

          <button
            type="button"
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={closeHandler}
            className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
          >
            <FiX className="w-8 h-8 text-blue-primary" />
          </button>
        </div>

        <h2 className='text-blue-primary font-bold text-xl text-center mx-auto my-8'>Dúvida</h2>

        <div className='text-lg'>
          <h3 className='font-semibold'>1. Como posso ler os livros?</h3>
          <p>Para ler os livros você precisa entrar com uma empresa parceira do dum dum livros da qual seja cliente ou fazer uma assinatura. Deste modo, você receberá dois novos livros todo os meses, para guardar para sempre! Além disso, você recebe uma biblioteca de presente no primeiro acesso.</p>
          <br />

          <h3 className='font-semibold'>2. Para que idade os livros são indicados?</h3>
          <p>Os livros são adequados para todas as idades, mas especialmente indicados para crianças de 3 aos 10 anos. Cada livro traz uma recomendação etária em sua apresentação.</p>
          <br />

          <h3 className='font-semibold'>3. Quantos livros eu recebo por mês?</h3>
          <p>São sempre dois livros novos a cada mês, que são seus e você pode baixar e guardar para sempre!</p>
          <br />

          <h3 className='font-semibold'>4. Posso escolher meus livros?</h3>
          <p>Um dos objetivos do dum dum livros é criar nos pequenos o hábito da leitura e apresentar um mundo de possibilidades. Por isso, temos uma equipe de curadoria formada por profissionais especializados que seleciona cuidadosamente os livros entregues e que farão parte da sua biblioteca. Queremos que os pequenos leitores tenham acesso não apenas ao que já conhecem e gostam, mas também ao novo, para que decidam o que mais gostam. Convidamos você a apreciar as escolhas da nossa curadoria. Se novo livro favorito pode estar a um clique de distância!</p>
          <br />

          <h3 className='font-semibold'>5. Quando chegam os livros novos?</h3>
          <p>Os novos livros chegam sempre no dia 1º de cada mês.</p>
          <br />

          <h3 className='font-semibold'>6. Preciso fazer download dos meus livros?</h3>
          <p>Seus livros podem ser lidos online e offline. Mas para acessá-los sem estar conectado à Internet você precisa fazer o download. Além disso, ao fazer o download, você guarda seus livros para sempre, mesmo que deixe de ser assinante ou cliente de uma empresa parceira.</p>
          <br />

          <h3 className='font-semibold'>7. Por que não consigo ler meus livros?</h3>
          <p>Se você não estiver conectado à Internet, não conseguirá ler os livros a não ser que tenha feito download anteriormente. Aproveite para baixá-los quando estiver conectado ao wifi e assim poder acessá-los em qualquer lugar, mesmo sem conexão.</p>
          <br />

          <h3 className='font-semibold'>8. Por quanto tempo ficam disponíveis os livros baixados?</h3>
          <p>Os novos livros ficam disponíveis para serem baixados por 2 anos desde a entrega. Faça o download neste período para guardar seus livros para sempre. Lembre-se, os livros são seus!</p>
          <br />

          <h3 className='font-semibold'>9. Por que não estou recebendo livros novos?</h3>
          <p>Se você parou de receber novos livros, significa que sua assinatura foi cancelada ou expirada, ou que você deixou de ter acesso por meio da empresa parceira a qual estava vinculado, seja porque deixou de ser cliente ou alterou seu plano. Nem todos os planos oferecidos pela empresa parceira podem dar direito aos livros do dum dum livros.</p>
          <br />

          <h3 className='font-semibold'>10. Quanto custa assinar o dum dum livros?</h3>
          <p>A assinatura custa R$24,90 por mês e com ela você adquire 2 novos livros por mês.</p>
          <br />

          <h3 className='font-semibold'>11. Quais as formas de pagamento aceitas?</h3>
          <p>Para assinar, você precisará utilizar um cartão de crédito.</p>
          <br />

          <h3 className='font-semibold'>12. Por quanto tempo é válida a assinatura?</h3>
          <p>Você pode cancelar sua assinatura a qualquer momento no próprio app. No menu principal, no canto superior direito, selecione o item Assinatura. Lá, você encontra as opções de gerenciamento de assinatura, incluindo o cancelamento. Se tiver qualquer dificuldade, acione o Fale Conosco.</p>
          <br />

          <h3 className='font-semibold'>13. Como posso cancelar uma assinatura?</h3>
          <p>Você pode cancelar sua assinatura a qualquer momento no próprio app. No menu principal, no canto superior direito, selecione o item Assinatura. Lá, você encontra as opções de gerenciamento de assinatura, incluindo o cancelamento. Se tiver qualquer dificuldade, acione o Fale Conosco.</p>
          <br />

          <h3 className='font-semibold'>14. Se eu cancelar a assinatura perco minha biblioteca?</h3>
          <p>Não! Você é dono dos livros da sua biblioteca, mesmo os que você recebeu de presente quando assinou o dum dum livros. Se você cancelar sua assinatura, não receberá mais novos livros, mas os livros da sua biblioteca permanecem com você. Lembre-se de fazer o download de todos os seus livros para guardá-los para sempre!</p>
          <br />

          <h3 className='font-semibold'>15. Como ter acesso com uma empresa parceira?</h3>
          <p>Clique em Entrar, e então escolha a opção Empresa Parceira. Localize a empresa da qual você é cliente e digite as credenciais de acesso informadas pela empresa. Se você não tiver ou não lembrar destas credenciais, procure a empresa.</p>
          <br />

          <h3 className='font-semibold'>16. Não consigo acessar com uma empresa parceira. Por que?</h3>
          <p>As empresas parceiras podem limitar o acesso ao dum dum livros a planos ou clientes específicos, a seu exclusivo critério. Por isso, mesmo que você seja cliente de uma empresa parceira, verifique se seu pano ou contrato abrangem os livros do dum dum livros.</p>
          <br />

          <h3 className='font-semibold'>17. Se eu deixar de ser cliente da empresa parceira perco minha biblioteca?</h3>
          <p>Não! Você é dono dos livros da sua biblioteca, mesmo os que você recebeu de presente quando acessou pela primeira vez com a empresa parceira. Se você deixou de ser cliente da empresa ou mudou seu plano para outro que não inclui o dum dum, não receberá mais novos livros, mas os livros da sua biblioteca permanecem com você. Lembre-se de fazer o download de todos os seus livros para guardá-los para sempre!</p>
          <br />

          <h3 className='font-semibold'>18. Não sei informar os dados de acesso da empresa parceira. Onde posso obtê-los?</h3>
          <p>Cada empresa parceira utiliza dados de acesso diferentes, que podem ser número de telefone, e-mail, CPF, número de cliente, código e outros. Ao tentar acessar o dum dum livros com determinada empresa você será informado sobre quais dados são utilizados por esta empresa como credencial de acesso. Se você não tiver estas credenciais, solicite à empresa.</p>
          <br />

          <h3 className='font-semibold'>19. Se eu desinstalar o aplicativo perco minha biblioteca?</h3>
          <p>Se você desinstalar o dum dum livros vamos entender que você não tem mais interesse na sua biblioteca e quer usar o espaço de armazenamento de seu dispositivo de outra forma. Assim, vamos eliminar os livros da sua biblioteca. Se mudar de ideia e quiser instalar novamente o app, você poderá baixar outra vez os livros, desde que o período de disponibilidade para download não tenha expirado.</p>
          <br />

          <h3 className='font-semibold'>20. Posso compartilhar os livros da minha biblioteca?</h3>
          <p>Queremos que você compartilhe histórias e momentos especiais, de mediação e descoberta, não livros. As obras estão protegidas pelas leis de direitos autorais, por isso não é permitido compartilhá-las. Se você gostou do livro, valorize os autores respeitando seus direitos e protegendo a obra.</p>
          <br />

          <h3 className='font-semibold'>21. Minha dúvida não está aqui, como posso resolver meu problema?</h3>
          <p>Entre em contato conosco, vamos ter enorme satisfação em esclarecer suas dúvidas, receber suas críticas ou elogios. Utilize a seção Fale conosco no menu principal ou escreva para <a className='text-blue-primary underline' href='mailto:contato@dumdumlivros.com.br'>contato@dumdumlivros.com.br</a></p>
          <br />

          <h3 className='font-semibold'>22. Como posso falar com o dum dum livros?</h3>
          <p>Utilize a seção Fale conosco no menu principal ou escreva para <a className='text-blue-primary underline' href='mailto:contato@dumdumlivros.com.br'>contato@dumdumlivros.com.br</a>. A gente promete que vai responder bem rápido!</p>
          <br />
        </div>
      </div>
    </Drawer>
  )
}

export default QuestionsModal